import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";

@Injectable({providedIn: 'root'})
export class SearchByPriceName {

  constructor ( private translateService: TranslateService ) {}
  
  getPriceName(code: string) {
    
    const priceNameMap: Record<string, string> = {
      'PRICE_CUSTOMER': this.translateService.instant('TRANSLATE.SELECT.PRICE.CUSTOMER'),
      'SELLER_PRICE': this.translateService.instant('TRANSLATE.SELECT.SELLER.PRICE'),
      'COST_FORD': this.translateService.instant('TRANSLATE.SELECT.COST.FORD'),
      'COST_WARRANTY': this.translateService.instant('TRANSLATE.SELECT.COST.WARRANTY'),
      'COST_SERVICE': this.translateService.instant('TRANSLATE.SELECT.COST.SERVICE')
    }



    return priceNameMap[code] || code;
  }


 
}
